export default __webpack_public_path__ + "static/demolition-interior-2b1a30bddb728ad23764a22ee8fdddbb.png";